import AutoStoriesIcon from "@mui/icons-material/AutoStories";

import { Icon } from "@mui/material";
const NotFound = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1 style={{ fontSize: "2em", marginBottom: "20px" }}>
        404
        {
          <Icon style={{ fontSize: 50 }}>
            <AutoStoriesIcon />
          </Icon>
        }
        - Page Not Found
      </h1>
      <p style={{ fontSize: "1.2em" }}>
        The page you are looking for does not exist.
      </p>
    </div>
  );
};

export default NotFound;
